import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneAlt, faHome, faBeer } from '@fortawesome/free-solid-svg-icons';

import logo from './images/logo.png'

const Header = ({config}) => (
  <div className="header">
    <Link to="/" className='logoGroup'>
      <img className="logo" src={logo} alt="logo main" />
    </Link>
    <div className="headerContactInfo">
    
      <div className="headerInfoSingleItem">
        <FontAwesomeIcon className="headerInfoSingleItemIcon" icon={faPhoneAlt} />
        <div className="headerInfoSingleItemContent">
          <h6>Phone</h6>
          <p>{config.businessInfo.phoneFormat}</p>
        </div>
      </div>
   
      {/* <div className="headerInfoSingleItem">
        <FontAwesomeIcon className="headerInfoSingleItemIcon" icon={faBeer} />
        <div className="headerInfoSingleItemContent">
          <h6>Address</h6>
          <p>{config.businessInfo.address01}</p>
          <p>{config.businessInfo.address02}</p>
        </div>
      </div> */}
    </div>
  </div>
);

export default Header;
